export const ru = {
    'no-phrases-for-replace': 'Фразы для замены не найдены'
};
